import { Col, Form } from 'react-bootstrap'
import { toast } from 'react-toastify';
import hocFrom from '../../components/forms/HocFrom';
import InputEditor from '../../components/inputs/InputEditor';
import InputFarsi from '../../components/inputs/InputFarsi';
import Loader from '../../components/layout/Loader';

const FormBusinessToBusinessNotification = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata }) => {
    const handelValue = (name, value) => {
        switch (name) {
            case "title":
                handelsetdataForm({ ...formdata, title: value })
                break;
            case "description":
                handelsetdataForm({ ...formdata, description: value })
                break;
            default:
                break;
        }
    }

    const Handelsubmit = event => {
        event.preventDefault()
        handelLoadingform(true)

        if (!formdata.title) {
            toast.error("وارد کردن عنوان الزامی است", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
                delete formdata.isActive
            dataUpdate.id ? handelUpdataFrom() : handelSend()
        }

    }
    return (
        loding ? <Loader />

            : <Form className='mt-3' >
                <Form.Row>
                        
                            <Col>
                                <InputFarsi label={'عنوان '} Placeholder={""} name={'title'} defaultValue={dataUpdate.title} handelValue={handelValue} />
                            </Col>
                        

                </Form.Row>
                    <Form.Row>
                        <Col>
                            <div className="form-group">
                                <label htmlFor="metaDescriptionTextarea"> توضیحات </label>
                                <textarea className="form-control" id="description"
                                    rows="6" defaultValue={dataUpdate ? dataUpdate.description : ''}
                                    onChange={(e) => handelValue('description', e.target.value)} ></textarea>
                            </div>
                        </Col>
                    </Form.Row>

                <Form.Row>
                    <Col  >
                        <button type='submit' className='btn btn-success' disabled={LoadingForm} onClick={Handelsubmit}>
                            {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : dataUpdate.id ? "ذخیره " : "ثبت"}
                        </button>
                    </Col> 
                </Form.Row>
            </Form>
    )
}
export default hocFrom(FormBusinessToBusinessNotification)
